@if (roadLanes().length>0 && roadLanesVisible()) {
  <div class="roadlanes-card ev-card">
    <div class="roadlanes-panel">
      @for (roadlane of roadLanes(); track roadlane) {
        <div class="roadlane-icon" [ngClass]="{'highlighted': roadlane.Highlighted}">
          <div class="roadlane-icon-images">
            @for (image of roadlane.Images; track image) {
              <img class="icon-img" [src]="'assets/icons/dark/lane_info/' + image" />
            }
          </div>
        </div>
      }
    </div>
  </div>
}